import useGetScreenshoot from "@/domains/screenshot/hooks/useGetScreenshot";

function ScreenshotContainer() {
  const { image } = useGetScreenshoot();

  if (!image) return null;

  return (
    <img src={image} crossOrigin="anonymous" width="10px" height="10px" alt="Taken screenshot" />
  );
}

export default ScreenshotContainer;
